import { Component, ViewChild } from "@angular/core";
import { UniStepperComponent } from "@universal-ui";

import { Unsubscriber } from "@shared/Components/Unsubscriber/unsubscriber.component";

import { CanalesService } from "../Shared/Services/canales.service";
import { NewUser, NewUserAccessData, NewUserPersonalData } from "../Shared/Types/new-user";

@Component({
  selector: "app-user-creation",
  templateUrl: "./user-creation.component.html",
})
export class UserCreationComponent extends Unsubscriber {
  public newUser: NewUser | null = null;
  @ViewChild("stepper") public stepper: UniStepperComponent;

  constructor(private canalesService: CanalesService) {
    super();
  }

  public onSubmitPersonalData(personalData: NewUserPersonalData): void {
    this.newUser = { ...this.newUser, ...personalData };
  }

  public onSubmitAccessData(accessData: NewUserAccessData): void {
    this.newUser = { ...this.newUser, ...accessData };
    this.anotherSubscription = this.canalesService.createNewUser(this.newUser).subscribe((user) => {
      this.stepper.next();
      if (user.userCode) {
        this.newUser.userCode = user?.userCode || this.newUser?.userCode;
      }
    });
  }

  public onReset(): void {
    this.newUser = null;
    this.stepper.reset();
  }

  public onBack(): void {
    this.stepper.previous();
  }
}
